import {
	CPF
} from 'cpf_cnpj';

const validate = (value) => CPF.isValid(CPF.strip(value));

export default validate;



// WEBPACK FOOTER //
// ./sources/support/validator/rules/cpf.js